<template>
  <div class="overflowTop">
    <div v-if="Lib.checkPower('beauty-3-ckjrcq',2)" class="receptionOverflow">
      <div class="flex">
        <div class="commonInfo">
          <div class="newContent" style="display: flex;flex-direction: row;">
            <h2>
              <label>{{ total ? total : '0' }}</label>
              <span>今日当班人数</span>
            </h2>
            <h2>
              <label>{{ leaveCount ? leaveCount : '0' }}</label>
              <span>今日请假人数</span>
            </h2>
            <h2>
              <label>{{ vacationCount ? vacationCount : '0' }}</label>
              <span>今日休假人数</span>
            </h2>
          </div>
        </div>
        <div style="margin: 20px 0;">
          <el-select v-model="listStatus" placeholder="请选择当前状态" @change="getListData('1')">
            <el-option label="全部" value="" selected></el-option>
            <el-option label="服务中" value="0"></el-option>
            <el-option label="空闲" value="1"></el-option>
            <el-option label="请假" value="2"></el-option>
            <el-option label="休假" value="3"></el-option>
          </el-select>
          <el-button type="primary" style="margin-left: 10px;" @click="leave('ruleForm')">员工请休假</el-button>
          <el-button class="ml_10" type="success" @click="leaveRecord">请休假记录</el-button>
        </div>
        <div class="commonTable">
          <el-table v-loading="loading" tooltip-effect="light" :data="tableData">
            <el-table-column prop="technicianName" label="员工姓名">
            </el-table-column>
            <el-table-column prop="phone" label="联系电话">
            </el-table-column>
            <el-table-column prop="job" label="职位">
            </el-table-column>
            <el-table-column label="当前状态">
              <template slot-scope="scope">
                <span v-if="scope.row.technicianStatus == 0" class="attendanceStatus as_1">服务中</span>
                <span v-else-if="scope.row.technicianStatus == 1" class="attendanceStatus as_2">空闲</span>
                <span v-else-if="scope.row.technicianStatus == 2" class="attendanceStatus as_3">请假</span>
                <span v-else-if="scope.row.technicianStatus == 3" class="attendanceStatus as_4">休假</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="tableData.length > 0" class="blockThree">
          <el-pagination background :current-page.sync="pageNum" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
      <gt-footer></gt-footer>

      <el-dialog class="leaveDialog" width="640px" title="员工请休假" :visible.sync="leaveDialog" :append-to-body="true">
        <el-form ref="ruleForm" :model="ruleForm" label-width="120px" class="demo-ruleForm" :rules="rules">
          <el-form-item label="选择员工：" prop="technicianid" required>
            <el-select v-model="ruleForm.technicianid" placeholder="请选择员工">
              <el-option v-for="item in usableStaffList" :key="item.technicianId" :label="item.technicianName" :value="item.technicianId+''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型：" prop="type" required>
            <el-select v-model="ruleForm.type" placeholder="请选择类型">
              <el-option label="请假" value="0"></el-option>
              <el-option label="休假" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="请/休假时间：" prop="time" required>
            <el-date-picker v-model="ruleForm.time" :picker-options="pickerOptions" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['12:00:00', '12:00:00']" :editable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="请/休假事由：">
            <el-input v-model="ruleForm.cause" type="textarea" :maxlength="100"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitLeave('ruleForm')">确定</el-button>
            <el-button @click="onCancel">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog class="leaveDialog" width="640px" title="提示" :visible.sync="leaveInfoDialog" :append-to-body="true">
        <div style="font-size: 15px;color: #333;height: 30px;line-height: 15px;">该员工本时段已有顾客预约，请慎重请假，若确要请假，请提前通知顾客。</div>
        <div style="font-size: 14px;color: #333;height: 30px;line-height: 15px;">预约信息如下：</div>
        <el-table tooltip-effect="light" :data="leaveInfoTableData">
          <el-table-column prop="memberName" label="顾客姓名" width="120">
          </el-table-column>
          <el-table-column label="预约时间" width="220">
            <template slot-scope="scope">
              <span>{{ scope.row.dateStr }} {{ scope.row.timeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="预约项目" width="120">
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" width="120">
          </el-table-column>
        </el-table>
        <div style="height: 80px;"></div>
        <div class="newLeaveBtn">
          <el-button @click="leaveInfoDialog = false">取消</el-button>
          <el-button type="primary" @click="submitLeave">确认请假</el-button>
        </div>
      </el-dialog>

      <el-dialog class="detailsDialogCq" width="1080px" title="请休假记录" :visible.sync="leaveRecordDialog" :append-to-body="true">
        <el-date-picker v-model="leaveRecordVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="chooseTime">
        </el-date-picker>
        <div class="commonTable">
          <el-table :data="leaveList" tooltip-effect="light">
            <el-table-column prop="technicianName" label="员工姓名" width="150">
            </el-table-column>
            <el-table-column label="请假时长" width="400">
              <template slot-scope="scope">
                <span>{{ scope.row.timeStart.substring(0,19) }}至{{ scope.row.timeEnd.substring(0,19) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cause" label="请假事由" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.cause ? scope.row.cause : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <yz-btn type="primary" @click="editLeave(scope.row.id,scope.row.technicianId,scope.row.timeStart,scope.row.timeEnd,scope.row.cause,scope.row.type)">修改</yz-btn>
                <yz-btn type="delete" @click="cancelLeave(scope.row.id)">取消</yz-btn>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="leaveList.length > 0" class="blockThree">
          <el-pagination background :current-page.sync="leaveCurrent" :page-size="leaveSize" layout="prev, pager, next, jumper" :total="leaveTotal" @size-change="handleSizeChange2" @current-change="handleCurrentChange2">
          </el-pagination>
        </div>
        <div class="commonTable">
          <el-table :data="vacationList" tooltip-effect="light">
            <el-table-column prop="technicianName" label="员工姓名" width="150">
            </el-table-column>
            <el-table-column label="休假时长" width="400">
              <template slot-scope="scope">
                <span>{{ scope.row.timeStart.substring(0,19) }}至{{ scope.row.timeEnd.substring(0,19) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cause" label="休假事由" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.cause ? scope.row.cause : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <yz-btn type="primary" @click="editLeave(scope.row.id,scope.row.technicianId,scope.row.timeStart,scope.row.timeEnd,scope.row.cause,scope.row.type)">修改</yz-btn>
                <yz-btn type="delete" @click="cancelLeave(scope.row.id)">取消</yz-btn>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="vacationList.length > 0" class="blockThree">
          <el-pagination background :current-page.sync="vacationCurrent" :page-size="vacationSize" layout="prev, pager, next, jumper" :total="vacationTotal" @size-change="handleSizeChange3" @current-change="handleCurrentChange3">
          </el-pagination>
        </div>
      </el-dialog>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import {
  getYgqxjList,
  getYgqxjData,
  getUsableStaff,
  postLeaveStaff,
  getLeaveList,
  getVacationList,
  getLeaveRecordDel,
  getBookOrderList4Time
} from './api';

export default {
  data() {
    return {
      // 禁用当前日之前的时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      listStatus: '', // 选择当前状态
      leaveRecordVal: '', // 选择时间段--请休假记录
      tableData: [], // 出勤列表
      pageNum: 1,
      rowCount: 1,
      total: '', // 今日当班人数
      leaveCount: '', // 请假人数
      vacationCount: '', // 休假人数
      pageSize: 10,
      leaveDialog: false, // 员工请休假--弹出框
      leaveInfoDialog: false, // 员工请休假--有预约弹出框
      leaveInfoTableData: [], // 有预约提示列表
      leaveRecordDialog: false, // 请休假记录--弹出框
      rules: { // 请假表单提示和规则
        technicianid: [{ required: true, message: '请选择员工', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        time: [
          {
            type: 'array',
            required: true,
            message: '请选择请/休假时间',
            trigger: 'change'
          },
          {
            type: 'array',
            required: true,
            message: '请选择请/休假时间',
            trigger: 'blur'
          }
        ],
        cause: [{ required: true, message: '请填写请/休假事由', trigger: 'blur' }, { required: true, message: '请填写请/休假事由', trigger: 'change' }]
      },
      ruleForm: { // 请休假表单数据
        technicianid: '',
        type: '',
        time: '',
        cause: ''
      },
      chooseLeaveId: '',
      leaveList: [], // 请假列表
      leaveTotal: 1,
      leaveSize: 5,
      leaveCurrent: 1,
      vacationList: [], // 休假列表
      vacationTotal: 1,
      vacationSize: 5,
      vacationCurrent: 1,
      usableStaffList: [], // 员工列表
      // 5.7
      loading: true,
    };
  },
  activated() {
    const vm = this;
    vm.pageNum = 1;
    vm.getListData('1');
    vm.getListInfo();
    vm.leaveRecordVal = this.Lib.G(7, 'yyyy-MM-dd');
  },
  methods: {
    // 选择时间
    chooseTime() {
      this.leaveRecord();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getListData(1);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData(val);
    },
    handleSizeChange2(val) {
      this.leaveCurrent = val;
      this.getLeaveList();
    },
    handleCurrentChange2(val) {
      this.leaveCurrent = val;
      this.getLeaveList();
    },
    handleSizeChange3(val) {
      this.vacationCurrent = val;
      this.getVacationList();
    },
    handleCurrentChange3(val) {
      this.vacationCurrent = val;
      this.getVacationList();
    },
    // 获取员工列表
    getListData(val) {
      const vm = this;
      vm.loading = true;
      const data = {
        pageSize: vm.pageSize,
        pageNum: val,
        status: vm.listStatus
      };
      getYgqxjList(data).then((res) => {
        vm.tableData = res.data.records;
        vm.pageSize = res.data.size;
        vm.pageTotal = res.data.total;
        vm.loading = false;
      });
    },
    // 获取员工状态
    getListInfo() {
      const vm = this;
      const data = {
        qDate: ''
      };
      getYgqxjData(data).then((res) => {
        vm.vacationCount = res.data.vacationCount;
        vm.leaveCount = res.data.leaveCount;
        vm.freeCount = res.data.freeCount;
        vm.total = res.data.total;
      });
    },
    // 请休假--弹出窗口
    leave(formName) {
      const vm = this;
      if (vm.Lib.checkPower('beauty-3-ygqxj') == false) return;
      const data = {};
      vm.chooseLeaveId = '';
      vm.ruleForm.cause = '';
      getUsableStaff(data).then((res) => {
        if (res.data.list.length > 0) {
          vm.usableStaffList = res.data.list;
          vm.leaveDialog = true;
          if (vm.ruleForm.technicianid || vm.ruleForm.type || vm.ruleForm.time) {
            vm.ruleForm = {
              technicianid: '',
              type: '',
              time: '',
              cause: ''
            };
            vm.$refs[formName].resetFields();
          }
        } else {
          vm.$message('没有空闲员工');
        }
      });
    },
    // 请休假--提交事件
    onSubmitLeave(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            technicianId: vm.ruleForm.technicianid,
            timeStart: vm.ruleForm.time[0],
            timeEnd: vm.ruleForm.time[1]
          };
          getBookOrderList4Time(data).then((res) => {
            if (res.data) {
              if (res.data.length > 0) {
                vm.leaveInfoDialog = true;
                vm.leaveInfoTableData = res.data;
              } else {
                vm.submitLeave();
              }
            } else {
              vm.submitLeave();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 请休假--提交事件（通过）
    submitLeave() {
      const vm = this;
      const data = {
        id: vm.chooseLeaveId,
        technicianid: vm.ruleForm.technicianid,
        timestart: vm.ruleForm.time[0],
        timeend: vm.ruleForm.time[1],
        cause: vm.ruleForm.cause,
        type: vm.ruleForm.type
      };
      postLeaveStaff(data).then((res) => {
        if (res.code == 0) {
          vm.$message({
            message: vm.chooseLeaveId ? '修改成功' : '添加成功',
            type: 'success'
          });
          vm.leaveDialog = false;
          vm.leaveInfoDialog = false;
          vm.$refs.ruleForm.resetFields();
          vm.ruleForm.cause = '';
          if (vm.chooseLeaveId) {
            vm.leaveRecord();
          }
          vm.getListData('1');
          vm.getListInfo();
        } else {
          console.log(res);
        }
      });
    },
    // 取消请休假
    onCancel() {
      this.leaveDialog = false;
    },
    // 请休假记录--弹出窗口
    leaveRecord() {
      if (this.Lib.checkPower('beauty-3-ckygqxjjl') == false) return;
      this.leaveRecordDialog = true;
      this.getLeaveList();
      this.getVacationList();
      this.leaveCurrent = 1;
      this.vacationCurrent = 1;
    },
    // 请假记录
    getLeaveList() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        pageNum: vm.leaveCurrent
      };
      if (vm.leaveRecordVal) {
        data.startDate = vm.leaveRecordVal[0];
        data.endDate = vm.leaveRecordVal[1];
      }
      getLeaveList(data).then((res) => {
        vm.leaveList = res.data.records;
        vm.leaveTotal = res.data.total;
        vm.leaveSize = res.data.size;
      });
    },
    // 休假记录
    getVacationList() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        pageNum: vm.vacationCurrent
      };
      if (vm.leaveRecordVal) {
        data.startDate = vm.leaveRecordVal[0];
        data.endDate = vm.leaveRecordVal[1];
      }
      getVacationList(data).then((res) => {
        vm.vacationList = res.data.records;
        vm.vacationTotal = res.data.total;
        vm.vacationSize = res.data.size;
      });
    },
    // 修改请休假
    editLeave(id, technicianId, timeStart, timeEnd, cause, type) {
      const vm = this;
      const data = {};
      getUsableStaff(data).then((res) => {
        if (res.data.list.length > 0) {
          vm.usableStaffList = res.data.list;
          vm.leaveDialog = true;
          vm.chooseLeaveId = id;
          vm.ruleForm.technicianid = `${technicianId}`;
          vm.ruleForm.time = [timeStart, timeEnd];
          vm.ruleForm.cause = cause;
          vm.ruleForm.type = `${type}`;
        } else {
          vm.$message('没有空闲员工');
        }
      });
    },
    // 取消请休假
    cancelLeave(id) {
      const vm = this;
      const data = {
        id
      };
      vm
        .$confirm('确定要删除这条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          getLeaveRecordDel(data).then((res) => {
            if (res.code == 0) {
              vm.$message({
                type: 'success',
                message: '取消成功'
              });
              vm.leaveRecord();
              vm.getListData('1');
              vm.getListInfo();
            } else {
              vm.$message('取消成功');
            }
          });
        })
        .catch(() => {
          vm.$message({
            type: 'info',
            message: '已退出取消'
          });
        });
    }
  },
};
</script>

<style>
.detailsDialogCq {
  position: fixed;
  z-index: 9999;
  overflow: hidden;
}
.leaveDialog {
  position: fixed;
  z-index: 9999;
  overflow: hidden;
}
.leaveDialog .el-textarea__inner {
  width: 400px;
}
.newSecondCode {
  float: right;
}
.newSecondCode span {
  float: left;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #333;
}
.newSecondCode .iconOne {
  display: block;
  width: 40px;
  height: 20px;
  background-color: #fcba65;
  border-radius: 4px;
  margin: 10px 10px 10px 0;
}
.newSecondCode .iconTwo {
  display: block;
  width: 40px;
  height: 20px;
  background-color: #7ed254;
  border-radius: 4px;
  margin: 10px 10px 10px 20px;
}
.newRecordsTable .el-table__body-wrapper table tbody tr td {
  min-width: 40px !important;
  padding: 0 !important;
  height: 40px;
}
.newRecordsTable .el-table__body-wrapper table tbody tr td:nth-child(2) {
  width: 83px !important;
}
.newRecordsTable .el-table th > .cell {
  min-width: 40px !important;
  padding: 0 !important;
}
.newRecordsTable .el-table th {
  min-width: 40px !important;
  padding: 0 !important;
}
.newRecordsTable .cell {
  min-width: 40px !important;
  padding: 0 !important;
  display: block !important;
  text-align: center !important;
}
.bg_color_0 {
  width: 40px;
  height: 39px;
  display: block;
}
.bg_color_1 {
  display: block;
  height: 39px;
  width: 40px;
  background-color: #fcba65;
}
.bg_color_2 {
  display: block;
  height: 39px;
  width: 40px;
  background-color: #7ed254;
}
.newLeaveBtn {
  position: absolute;
  bottom: 0;
  right: 30px;
  background-color: #fff;
  padding: 20px 0;
  z-index: 1;
  width: 580px;
  text-align: right;
}
</style>

<style lang="less" scoped>
.overflowTop {
  overflow: visible;
}
.attendanceNav {
  width: 100%;
  margin: 15px 0 20px 0;
  ul {
    list-style: none;
    display: flex;
    li {
      height: 60px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      width: 20%;
      margin-right: 20px;
      cursor: pointer;
      img {
        width: 34px;
        height: 34px;
        margin: 13px 20px;
        float: left;
      }
      span {
        font-size: 14px;
        color: #333;
        height: 40px;
        line-height: 40px;
        float: left;
        margin: 10px 0;
      }
    }
  }
}
.attendanceStatus {
  border-radius: 4px;
  font-size: 12px;
  padding: 8px 10px;
  display: block;
  width: 36px;
  text-align: center;
  height: 12px;
  line-height: 12px;
}
.as_1 {
  color: #fd5c8c;
  background-color: #ffe9ee;
}
.as_2 {
  background-color: #e4f8eb;
  color: #72da95;
}
.as_3 {
  background-color: #ffebec;
  color: #f7606c;
}
.as_4 {
  background-color: #ffeee4;
  color: #ef9359;
}
</style>
